import classNames from 'classnames'

import type { IChipWithInputView } from './chip-with-input.types'

import './chip-with-input.styles.scss'

export function ChipWithInputView({
  placeholderText,
  charLimit,
  isEditing,
  inputValue,
  inputRef,
  wrapperRef,
  handleKeyDown,
  handleCancel,
  setIsEditing,
  setInputValue,
}: IChipWithInputView) {
  return (
    <button
      ref={wrapperRef}
      type="button"
      className={classNames('chip-with-input', {
        'display-mode': !isEditing,
      })}
      onClick={() => setIsEditing(true)}
    >
      {isEditing ? (
        <input
          ref={inputRef}
          value={inputValue}
          maxLength={charLimit}
          onChange={e => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={handleCancel}
          placeholder={placeholderText}
          className="input-field"
        />
      ) : (
        <span>{placeholderText}</span>
      )}
    </button>
  )
}
